module.exports = __webpack_public_path__ + "assets/person-407a4f03c3c62edae45be8ad07fa28bb.svg";